import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-number" }
const _hoisted_2 = { class: "segments" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card", { cardSelected: _ctx.isSelected }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.card?.type ? _ctx.t(_ctx.card.type) : _ctx.index + 1), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.segments, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "segment",
          style: _normalizeStyle({ backgroundColor: item.color })
        }, null, 4))
      }), 128))
    ])
  ], 2))
}